import { clickOutBlackListRegexps } from '../regexps';
import type { Validator } from './types';

export function makeClickOutLinkValidator(
    message: string,
    required: boolean = true,
): Validator<string> {
    return (value?: string) => {
        if (!required && !value) {
            return;
        }

        return !value || clickOutBlackListRegexps.some((re) => re.test(value))
            ? message
            : undefined;
    };
}
